import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';

import { Loader } from '../../../../components/Loader';
import { initiateNewTransporterValue, setNewTransporterValue } from '../../actions';
import { selectNewTransporter, selectNewTransporterValue } from '../../selectors';

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { REQUEST_TRANSPORTER_PROPERTY_UPDATE } from '../../constants';
import { selectWork, selectWorks } from '../../../Api/selectors';

dayjs.extend(customParseFormat);
const DROPDOWN_OPTIONS = {};

const Container = styled.div`
  margin-bottom: 8px;
  .formField {
    .label {
      text-transform: capitalize;
      margin-bottom: 6px;
      color: #6c757d;
    }
  }

  .rightDecorationBlock {
    width: 100px;
    display: flex;

    .deleteBtn {
      background-color: #d50046;
    }
  }
`;

const STATE = {
  value: '',
};

/* eslint-disable react/prefer-stateless-function */
class TransporterCreateFieldComp extends BaseComponent {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {
    this.props.initiateValue();
  }

  isTextariaBlock() {
    return ['remarks'].indexOf(this.props.type) > -1;
  }

  isDate() {
    return ['scheduledDate', 'datePlanned', 'dateToPlan'].indexOf(this.props.type) > -1;
  }

  wrap(children) {
    const containsCheckbox = element => {
      if (React.isValidElement(element) && element.props) {
        return typeof element.props.className === 'string' && element.props.className.includes('checkbox');
      }
      return false;
    };

    const isCheckboxComp = React.Children.toArray(children).some(child => containsCheckbox(child));

    if (isCheckboxComp) {
      return <div>{children}</div>;
    } else {
      return (
        <div>
          <label className="form-label">{this.formFieldLabel()}</label>
          {children}
        </div>
      );
    }
  }

  formFieldLabel() {
    return this.lbl(`vehicle.property.${this.props.type}`);
  }

  detailsField() {
    return (
      <div>
        <textarea
          value={this.props.value}
          onChange={evt => this.props.setValue(evt.target.value)}
          className="form-control"
        />
      </div>
    );
  }

  reset() {
    this.setState({ ...STATE });
  }

  render() {
    if (this.props.work) return <Loader small />;

    return <Container>{this.wrap(this.renderField())}</Container>;
  }

  renderField() {
    if (this.props.value === undefined) return null;
    let disabled = false;
    if (this.props.type === 'import') disabled = this.isImportDisabled();

    if (this.isTextariaBlock()) {
      return this.detailsField();
    }

    switch (this.props.type) {
      case 'name':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'surname':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'phoneNumber':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
      case 'email':
        return (
          <input
            className="form-control"
            key={this.props.type}
            value={this.props.value}
            onChange={evt => this.props.setValue(evt.target.value)}
          />
        );
    }
  }
}

TransporterCreateFieldComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_TRANSPORTER_PROPERTY_UPDATE),

    value: selectNewTransporterValue(ownProps.type),
    values: selectNewTransporter(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      dispatch(setNewTransporterValue(name, value));
    },

    initiateValue() {
      dispatch(initiateNewTransporterValue(ownProps.type));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const TransporterCreateField = compose(withConnect, withRouter)(TransporterCreateFieldComp);
